import React, { useState } from "react";
import Tooltip from "../drops/tooltip";
import Flex from "../templates/flex";
import Box from "../templates/box";
import { Icon } from "../icon";
import { ConfirmationDialog } from "../confirmation-dialog";
var Action = function (_a) {
    var id = _a.id, icon = _a.icon, handleAction = _a.handleAction, tooltipText = _a.tooltipText, confirmation = _a.confirmation, confirmationTitle = _a.confirmationTitle, confirmationMessage = _a.confirmationMessage, handleDecline = _a.handleDecline, confirmLabel = _a.confirmLabel, declineLabel = _a.declineLabel, actionButtonDirection = _a.actionButtonDirection, testPrefix = _a.testPrefix;
    var _b = useState(false), isConfirmationOpen = _b[0], setConfirmationOpen = _b[1];
    var onActionClicked = function () {
        if (confirmation) {
            setConfirmationOpen(true);
            return;
        }
        handleAction();
    };
    var onActionDeclined = function () {
        setConfirmationOpen(false);
        handleDecline === null || handleDecline === void 0 ? void 0 : handleDecline();
    };
    var onActionConfrimed = function () {
        setConfirmationOpen(false);
        handleAction === null || handleAction === void 0 ? void 0 : handleAction();
    };
    return (React.createElement(React.Fragment, null,
        isConfirmationOpen && (React.createElement(ConfirmationDialog, { actionButtonDirection: actionButtonDirection, declineLabel: declineLabel, confirmLabel: confirmLabel, title: confirmationTitle, message: confirmationMessage, handleDecline: onActionDeclined, handleConfirm: onActionConfrimed })),
        React.createElement(Tooltip, { content: tooltipText },
            React.createElement(Flex, { "data-testid": "netdata-table-action-".concat(id).concat(testPrefix), alignItems: "center", justifyContent: "center", height: "100%", _hover: { background: "borderSecondary" }, cursor: "pointer", key: id, width: 10, onClick: onActionClicked },
                React.createElement(Box, { as: Icon, name: icon })))));
};
export default Action;
